module.exports = __webpack_public_path__ + "img/r-3-btn.db31fb4b.png";